import Button from "../primitives/button";
import styles from "./styles.module.css";

interface OfferProps {
  offer: any;
  sportsbook: {
    title: string;
    thumbnailUrl: string;
  };
}

export default function Offer(props: OfferProps) {
  const { offer, sportsbook } = props;

  return (
    <div className={styles.offerBox}>
      {sportsbook.thumbnailUrl && (
        <div className={styles.offerBoxIcon}>
          <img
            src={sportsbook.thumbnailUrl}
            alt={offer.attributes.title}
            className="block w-[50px] h-[50px]"
          />
        </div>
      )}
      <div className="flex flex-col flex-1 md:flex-auto">
        {sportsbook.title && (
          <span className="text-secondary-500 text-title-lg">
            {sportsbook.title}
          </span>
        )}
        {offer.attributes.title && (
          <h3 className="text-headline-bold text-secondary-100 uppercase [text-wrap:balance]">
            {offer.attributes.title}
          </h3>
        )}
      </div>
      <div className={styles.offerBoxBtnWrap}>
        {offer.attributes.promo_code && (
          <Button
            color="tertiary"
            variant="info"
            className={styles.btnOffer}
            target="_blank"
          >
            <span>{offer.attributes.promo_code}</span>
            <span className="text-secondary-500 text-title-sm-medium capitalize">
              Promo Code
            </span>
          </Button>
        )}
        {offer.attributes.button_text && offer.attributes.button_url && (
          <Button
            color="primary"
            size="md"
            variant="standard"
            className={styles.btnClaim}
            href={offer.attributes.button_url}
            target="_blank"
          >
            {offer.attributes.button_text}
          </Button>
        )}
      </div>
    </div>
  );
}
